import { useViewport } from '../hooks'
import mediaqueries from '../sass/_mediaqueries.scss'

import { ChartArea } from 'chart.js'
import moment from 'moment'

export function matchActiveTransports(total: any, actives: any) {
  if (total?.length > 0 && actives?.length > 0) {
    const match: any = total.filter(
      (item: any) => actives.indexOf(item.uuid) !== -1
    )
    return match
  } else return []
}

export function locationOptions(list: any, config: any) {
  if (config === 'nolocation') {
    return list.filter((item: any) => item.value !== 'go_to_work')
  }
  return list
}

export function filterEmptyKeys(object: any) {
  for (const key of Object.keys(object)) {
    if (object[key] === '' || object[key]?.length === 0) {
      delete object[key]
    }
  }
  return object
}

export function createGradient(
  ctx: CanvasRenderingContext2D,
  area: ChartArea,
  color: any
) {
  const colorStart = color + '00'
  const colorEnd = color + '66'
  const gradient = ctx.createLinearGradient(0, area.bottom, 0, area.top)
  gradient.addColorStop(0, colorStart)
  gradient.addColorStop(0.9, colorEnd)
  return gradient
}

export function tableLimit(customLimit: number, modal?: boolean) {
  const { screenWidth } = useViewport()
  const breakpointLarge = Number(
    mediaqueries.breakpointDesktopLarge.replace('px', '')
  )
  let limit = customLimit
  if (screenWidth >= breakpointLarge) limit = 14
  if (screenWidth >= breakpointLarge && modal) limit = 13
  return limit
}

export function submitAfterEnter(e: any, fx: Function) {
  if (e.key === 'Enter') fx(e)
}

export function getRepetitions(array: any, key: string) {
  const result: any = []
  const map = new Map()
  for (const item of array) {
    if (!map.has(item[key])) {
      map.set(item[key], true)
      result.push({
        parent: item[key],
        count: 1,
      })
    } else {
      for (const i of result) {
        if (i[key] === item[key]) {
          i.count += 1
        }
      }
    }
  }
  return result
}

export function charactersRemaining(text: string, limit: number) {
  const remaining = limit - text.length
  return remaining
}

export const applyDuotoneFilter = (
  imageUrl: string,
  color: string,
  intensity: number
): Promise<string> => {
  return new Promise(resolve => {
    const img = new Image()
    img.crossOrigin = 'Anonymous'
    img.onload = () => {
      const canvas = document.createElement('canvas')
      const ctx = canvas.getContext('2d')
      if (!ctx) {
        resolve(imageUrl) // Si no hay contexto, devolver la imagen original
        return
      }

      // Configurar el canvas con las dimensiones de la imagen
      canvas.width = img.width
      canvas.height = img.height

      // Dibujar la imagen original en el canvas
      ctx.drawImage(img, 0, 0, img.width, img.height)

      // Aplicar el filtro duotono solo si la intensidad es mayor que 0
      if (intensity > 0) {
        const intensityFactor = intensity / 100

        // Obtener los datos de la imagen
        const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height)
        const data = imageData.data

        // Parsear el color
        const r = parseInt(color.slice(1, 3), 16)
        const g = parseInt(color.slice(3, 5), 16)
        const b = parseInt(color.slice(5, 7), 16)

        // Aplicar el efecto duotono con más saturación y contraste
        for (let i = 0; i < data.length; i += 4) {
          // Obtener los valores RGB originales
          const origR = data[i]
          const origG = data[i + 1]
          const origB = data[i + 2]

          // Convertir a escala de grises usando la fórmula de luminancia
          const gray = 0.299 * origR + 0.587 * origG + 0.114 * origB

          // Mejorar el contraste (similar al enfoque de Canva)
          const contrast = 1.1
          const brightnessFactor = 0.95
          const enhancedGray = Math.min(
            255,
            Math.max(0, (gray - 128) * contrast + 128 * brightnessFactor)
          )

          // Aplicar color con saturación aumentada
          const mixedR =
            enhancedGray * (1 - intensityFactor * 0.8) +
            r * intensityFactor * 1.2
          const mixedG =
            enhancedGray * (1 - intensityFactor * 0.8) +
            g * intensityFactor * 1.2
          const mixedB =
            enhancedGray * (1 - intensityFactor * 0.8) +
            b * intensityFactor * 1.2

          // Aplicar el resultado
          data[i] = Math.min(255, Math.max(0, mixedR))
          data[i + 1] = Math.min(255, Math.max(0, mixedG))
          data[i + 2] = Math.min(255, Math.max(0, mixedB))
        }

        // Volver a colocar los datos de imagen modificados
        ctx.putImageData(imageData, 0, 0)
      }

      // Convertir el canvas a URL para la vista previa
      resolve(canvas.toDataURL('image/jpeg'))
    }

    img.onerror = () => {
      resolve(imageUrl) // En caso de error, devolver la imagen original
    }

    img.src = imageUrl
  })
}
